import type { ComparisonMatrixCriterion } from '@all-manager/design-system-v2';
import { Quote, QuoteCompaisonColumnDatabase } from '../../../../types';

type Props = {
  columns: QuoteCompaisonColumnDatabase[];
  quotes: Quote[];
};

const TTC_PATTERN = /ttc/i;

/** The price shown on collapsed phone cards: the TTC amount when there is one, the first amount otherwise. */
function getSummaryColumnId(columns: QuoteCompaisonColumnDatabase[]) {
  const numberColumns = columns.filter((column) => column.type === 'number');

  return (numberColumns.find((column) => TTC_PATTERN.test(column.label)) ?? numberColumns[0])?.id;
}

export function useQuoteComparison(props: Props) {
  const visibleColumns = props.columns.filter((column) => column.visible);

  function toCriterion(
    column: QuoteCompaisonColumnDatabase,
    renderValue: (column: QuoteCompaisonColumnDatabase, quote: Quote) => ComparisonMatrixCriterion['values'][string],
  ): ComparisonMatrixCriterion {
    return {
      id: column.id,
      label: column.label,
      numeric: column.type === 'number',
      values: Object.fromEntries(props.quotes.map((quote) => [quote.id, renderValue(column, quote)])),
    };
  }

  return {
    visibleColumns,
    summaryColumnId: getSummaryColumnId(visibleColumns),
    toCriterion,
  };
}
